import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { tryBiometricLogin } from '@/components/flutter/BiometricLogin';
import { checkCookiebot } from '@/utilities/checkCookiebot';

import './BiometricLoginPage.css';

export function BiometricLoginPage({
  login,
  startNormal,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  login: (username: string, password: string, rememberbe: boolean, isBiometricLogin: boolean) => Promise<any>;
  startNormal: (notsupported: boolean) => void;
}) {
  const { t } = useTranslation();

  useEffect(() => {
    function handleError(error?: string) {
      /* possible errors: notsupported empty failedbio failed */
      console.debug('biometric login failed', error);
      startNormal(error === 'notsupported');
    }

    async function biologin() {
      try {
        const resp = await tryBiometricLogin();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const error = (resp as any).error;
        if (error) {
          handleError(error);
          return;
        }
        await login(resp.username, resp.password, true, true); // FIXME
        // mikor johet ez ? csak ha nem appban vagyunk ??? vagy ha mas jott vissza
      } catch (e) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const error = (e as any)?.error as string;
        handleError(error);
      }
    }
    // TODO remove this
    if (checkCookiebot()) Cookiebot.hide();
    void biologin();
  }, []);

  return (
    <div className="biometric1-page">
      <div className="biometric1-page-title">{t('login.biometric.title')}</div>
      <div className="biometric1-page-subtitle">{t('login.biometric.subtitle')}</div>

      <div className="biometric1-page-icons">
        <img src="svg/faceid.svg"></img>
      </div>

      <div className="biometric1-page-subtitle">{t('login.biometric.subtitle2')}</div>

      <div className="biometric1-page-icons">
        <img src="svg/fingerprint.svg"></img>
      </div>
    </div>
  );
}
